const initImagePastListWidget = () => {
    //#region tab click => image change and content display 
    const tabSelectorArray = document.querySelectorAll("[data-tab-selector]");
    const tabContentArray = document.querySelectorAll("[data-tab-content]");
    if (tabSelectorArray && tabSelectorArray.length > 0) {
        const imageElement = document.querySelector("[data-img]");
        tabSelectorArray.forEach(tabSelector => {
            //bind a click event
            tabSelector.addEventListener("click", () => {
                //deactivate all tabs
                tabSelectorArray.forEach(x => x.classList.remove("active"));
                //deactivate all content
                tabContentArray.forEach(x => x.classList.remove("active"));
                //set active to selected tab
                tabSelector.classList.add("active");
                //set active to corresponding content
                document.querySelector(`[data-tab-content="${tabSelector.getAttribute("data-tab-selector")}"]`).classList.add("active");
                //activate corresponding picture
                imageElement.src = tabSelector.getAttribute("data-src");
            });
        });
    }
    //#endregion
    //#region tab slider
    const tabSliderSelector = "[data-tab-slider]";
    const tabSliderArray = document.querySelectorAll(tabSliderSelector);
    if (tabSliderArray && tabSliderArray.length > 0) {
        const config = new CarouselConfig();
        config.sliderSelector = tabSliderSelector;
        config.cellAlign = CellAlign.left;
        config.contain = true;
        config.autoPlay = false;
        config.wrapAround = true;
        config.showArrows = false;
        config.activateCustomButtons = true;
        config.groupCells = false;
        config.adaptiveHeight = false;
        config.imagesLoaded = true;
        const responsiveCarousel = new ResponsiveCarousel();
        responsiveCarousel.initCarousel(config);
    }
    //#endregion
};
